// src/services/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://aubfdxmxxcrsaztnfkgm.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF1YmZkeG14eGNyc2F6dG5ma2dtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzMyNTc5NDIsImV4cCI6MjA0ODgzMzk0Mn0.ApeaSo0Cm4FaXIKcHMgYoLPPwFusCr-2S9GnWTvM7mo';

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase credentials');
}

export const supabase = createClient(supabaseUrl, supabaseKey);
